module.exports = __webpack_public_path__ + "media/images/Icon-door-02adaffdf81748771ba74711093a0dbe.svg";